/** Survives OAuth redirect even if ?claimBrandTrial=1 is dropped from the URL. */
export const BRAND_TRIAL_CLAIM_PENDING_KEY = 'brandTrialClaimPending';

export function markBrandTrialClaimPending(): void {
  try {
    sessionStorage.setItem(BRAND_TRIAL_CLAIM_PENDING_KEY, '1');
  } catch {
    // ignore quota / private mode
  }
}

export function clearBrandTrialClaimPending(): void {
  try {
    sessionStorage.removeItem(BRAND_TRIAL_CLAIM_PENDING_KEY);
  } catch {
    // ignore
  }
}

export function isBrandTrialClaimPending(): boolean {
  try {
    return sessionStorage.getItem(BRAND_TRIAL_CLAIM_PENDING_KEY) === '1';
  } catch {
    return false;
  }
}
